const pushhero = {
    name: 'Push Hero',
    slug: 'pushhero',
    keywords: ['macos', 'ios', 'push', 'notification', 'certificate', 'authentication', 'apns', 'bundle', 'test', 'reliable', 'robust', 'edit', 'template', 'save'],
    header: {
        background: '#E1E28E',
        twitter: 'PushHeroApp'
    },
    headline: {
        title: 'Reliable push notification testing tool',
        text: 'Push Hero is a native macOS application written in pure Swift that allows us to easily test push notifications. Support new push features of iOS 13 and macOS 10.15.',
        imageUrl: 'https://user-images.githubusercontent.com/2284279/99895828-e55b3180-2c8a-11eb-9400-9660a8aba710.png',
    },
    productHunt: {
        link: 'https://www.producthunt.com/posts/push-hero-2',
        id: '184937'
    },
    download: {
        appstore: [
            {
                id: 'id1499227284',
                platform: "macOS",
                version: "10.15" 
            }
        ]
    },
    showcase: {
        platforms: ['macOS'],
        background: '#E0E282',
        tagline: 'Test iOS push notifications',
        detail: true
    },
    blocks: [
        {
            style: 'g1',
            items: [
                {
                    title: 'Native',
                    subtitle: 'Written in pure Swift and truly native to embrace the Mac experience.',
                    icon: 'file_54'
                },
                {
                    title: 'No subscription',
                    subtitle: 'No recurring subscription. Buy once, use forever. Even for future updates.',
                    icon: 'shopping_2'
                },
                {
                    title: 'No tracking',
                    subtitle: 'No analysis tracking. No data collecting.',
                    icon: 'sport_12'
                },
                {
                    title: 'Reliable',
                    subtitle: 'Follow APNS specification closely to ensure reliable experience.',
                    icon: 'ui_4'
                },
                {
                    title: 'Fast',
                    subtitle: 'Optimize for better performance when sending and parsing push responses.',
                    icon: 'eco_29'
                },
                {
                    title: 'Dark mode',
                    subtitle: 'Gorgeous dark mode themes',
                    icon: 'weather_6'
                }
            ]
        },
        {
            style: 's1',
            title: 'Full APNS specifications',
            subtitle: 'Follow Apple Push Notification guidelines closely',
        },
        {
            style: 'h1',
            title: 'Easy authentication',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/105032717-6fd7cb80-5a57-11eb-8745-69fd044e5b9e.png',
            items: [
                {
                    title: 'Multiple scenarios',
                    subtitle: 'Create as many test scenarios as you want. Duplicate them with ease.',
                    icon: 'furniture_5'
                },
                {
                    title: 'Certificate based authentication',
                    subtitle: 'Select certificacte .p12 file with optional passphrase',
                    icon: 'medical_27'
                },
                {
                    title: 'Key based authentication',
                    subtitle: 'Select key .p8 file with key ID and team ID.',
                    icon: 'sport_29'
                },
                {
                    title: 'Sandbox and production environment',
                    subtitle: 'Specify which APNS server you want to test against',
                    icon: 'sport_27'
                }
            ]
        },
        {
            style: 'h2',
            title: 'Header and body',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/105033090-f12f5e00-5a57-11eb-85d3-8647ce8ffa0f.png',
            items: [
                {
                    title: 'All kinds of push types',
                    subtitle: 'Support alert, voip, complication, background, mdm, fileprovider',
                    icon: 'communication_10'
                },
                {
                    title: 'Multiple device tokens',
                    subtitle: 'Send to one or multiple device tokens at the same time. Gracefully handle expiration duration of each token.',
                    icon: 'communication_73'
                },
                {
                    title: 'Tooltip',
                    subtitle: 'Touch on info button on each field to view explanation.',
                    icon: 'communication_25'
                },
                {
                    title: 'JSON validation',
                    subtitle: 'Inspect JSON message field and reports where the error is.',
                    icon: 'communication_51'
                }
            ]
        },
        {
            style: 's1',
            title: 'Push history',
            subtitle: 'Save record for each of your test results.',
        },
        {
            style: 'h2',
            title: 'Detailed information for each test request',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/99895726-c314e400-2c89-11eb-98c1-f3482342d843.png',
            items: [
                {
                    title: 'General info',
                    subtitle: 'View environment URI and device token',
                    icon: 'eco_23'
                },
                {
                    title: 'Request and response',
                    subtitle: 'View all headers and body',
                    icon: 'drink_61'
                },
                {
                    title: 'Readable reason',
                    subtitle: 'Parse reason code and render in pretty readable format',
                    icon: 'weather_29'
                }
            ]
        },
    ]
}

export default pushhero